import "maplibre-gl/dist/maplibre-gl.css";
import "./styles/global.css";
// Avant tout usage de schéma : désactive la compilation JIT de zod, que la CSP
// interdit. Voir lib/zod-config.ts.
import "./lib/zod-config.ts";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app.tsx";
import { I18nProvider } from "./i18n/index.ts";

const container = document.getElementById("root");

if (container === null) {
  throw new Error("Élément #root introuvable dans index.html.");
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
